const getCookie = function (name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
}

export default {
  init ({ commit }) {
    let lang = getCookie('lang')
    if (!lang) {
      document.cookie = "lang=en; max-age=3600";
    } else {
      commit('UPDATE_LANG', lang)
    }
  },
  setLang ({commit}, lang) {
    document.cookie = `lang=${lang}; max-age=3600`;
    commit('UPDATE_LANG', lang)
  },
  getSiteContent ({ commit, state }) {
    if (!state.content) {
      fetch(`${process.env.VUE_APP_API_ROOT}site-content.json`)
      .then(res => res.json())
      .then(json => commit('UPDATE_CONTENT', json))
    }
  },
  getEvents ({ commit, state }) {
    if (!state.events) {
      fetch(`${process.env.VUE_APP_API_ROOT}en/events.json`)
        .then(res => res.json())
        .then(json => commit('UPDATE_EVENTS', json))
    }
  },
  async search ({ commit, state }) {
    commit('SET_SEARCH_RESULTS', null)
    fetch(`${process.env.VUE_APP_API_ROOT}en/search?q=${state.searchTerm}`)
    .then(res => res.json())
    .then((json) => {
      commit('SET_SEARCH_RESULTS', json)
    })
  }
}
